export default new class NewsCard {
  constructor() {
    this.newsCard = 'news-card';
    this.fixRubricWidth();
  }

  /**
     * Set width for rubric by inner span
     *
     * used in pagination (themes/jurist/partials/project/common/pagination/pagination.js)
     */
  fixRubricWidth() {
    const $newsCard = $(`.${this.newsCard}`);
    const $rubric = $newsCard.find('.news-card__rubric');

    if (!$newsCard.length || !$rubric.length) return;

    // setTimeout for iphone
    setTimeout(() => {
      $rubric.each(function setWidth() {
        const $span = $(this).find('span');

        $(this).width(`${$span.width() + 2}px`);
      });
    }, 1000);
  }
}();
